<script setup lang="ts">
export interface Props {
    full?: boolean
    half?: boolean
    empty?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    full: false,
    half: false,
    empty: false
})
</script>

<template>
    <svg
        v-if="props.full"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5451 15.8453L15.0323 18.4516C15.5454 18.7496 16.1784 18.3069 16.0422 17.7453L14.8514 12.8332L18.819 9.52557C19.2716 9.14821 19.0302 8.43271 18.4336 8.3832L13.2105 7.94978L11.1688 3.32106C10.9352 2.79141 10.1551 2.79142 9.92147 3.32107L7.87978 7.94978L2.65467 8.38337C2.0583 8.43286 1.81673 9.14778 2.26879 9.52534L6.22936 12.8332L5.04526 17.7476C4.90999 18.309 5.54264 18.7509 6.05536 18.4531L10.5451 15.8453Z"
            fill="#F59F0A"
        />
    </svg>

    <svg
        v-else-if="props.half"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.1868 14.1285V5.63852L11.8092 9.32666L15.9648 9.66443L12.8149 12.2936L13.7542 16.2008L10.1868 14.1285ZM18.4606 9.52628C18.9137 9.14859 18.6715 8.43244 18.0742 8.38368L12.8529 7.95746L10.8108 3.32144C10.5773 2.79129 9.79641 2.79129 9.56288 3.32144L7.52078 7.95746L2.2975 8.38385C1.70045 8.43259 1.45806 9.14816 1.91059 9.52606L5.8699 12.8324L4.68548 17.7475C4.55018 18.309 5.183 18.7509 5.69586 18.4531L10.1869 15.845L14.6753 18.4516C15.1885 18.7496 15.8216 18.3069 15.6854 17.7451L14.4943 12.8324L18.4606 9.52628Z"
            fill="#F59F0A"
        />
    </svg>
    <svg
        v-else-if="props.empty"
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.7365 21.9275L11.0881 25.2432L12.5753 18.9916L7.58787 14.7849L14.1677 14.2445L16.7365 8.34348L19.3053 14.2445L25.8851 14.7849L20.8977 18.9916L22.3849 25.2432L16.7365 21.9275ZM29.8367 14.5639C30.5541 13.9596 30.1706 12.8138 29.2248 12.7358L20.9578 12.0538L17.7245 4.63619C17.3547 3.78794 16.1183 3.78794 15.7486 4.63619L12.5152 12.0538L4.24504 12.736C3.29971 12.814 2.91592 13.9589 3.63243 14.5636L9.90134 19.8537L8.02601 27.7179C7.81178 28.6162 8.81375 29.3233 9.62577 28.8468L16.7365 24.6738L23.8432 28.8444C24.6558 29.3212 25.6582 28.6129 25.4426 27.7141L23.5567 19.8537L29.8367 14.5639Z"
            fill="#D4D4D8"
        />
    </svg>
</template>
